// This file is generated by the openedx/frontend-platform's "intl-import.js" script.
//
// Refer to the i18n documents in https://docs.openedx.org/en/latest/developers/references/i18n.html to update
// the file and use the Micro-frontend i18n pattern in new repositories.
//

// Skipped import due to missing 'frontend-component-ai-translations/index.js' likely due to empty translations..
// Skipped import due to missing 'frontend-lib-content-components/index.js' likely due to empty translations..
import messagesFromFrontendPlatform from './messages/frontend-platform';
import messagesFromParagon from './messages/paragon';
import messagesFromFrontendComponentFooter from './messages/frontend-component-footer';
import messagesFromFrontendAppCourseAuthoring from './messages/frontend-app-course-authoring';

export default [
  messagesFromFrontendPlatform,
  messagesFromParagon,
  messagesFromFrontendComponentFooter,
  messagesFromFrontendAppCourseAuthoring,
];
